import { MessageBarType, Stack, Text } from "@fluentui/react";
import { containerStyles, formContainerStyles, innerTitleStyles, lgContainerStyles, lgInnerTitleStyles, lgSubContainerStyles, lgSubInnerTitleStyles, lgSubTitleStyles, lgTitleContainerStyles, lgTitleStyles, mdContainerStyles, mdInnerTitleStyles, mdSubContainerStyles, mdSubInnerTitleStyles, mdSubTitleStyles, mdTitleContainerStyles, mdTitleStyles, smContainerStyles, smInnerTitleStyles, smSubContainerStyles, smSubInnerTitleStyles, smSubTitleStyles, smTitleContainerStyles, smTitleStyles, subContainerStyles, subInnerTitleStyles, subTitleStyles, titleContainerStyles, titleStyles, xlContainerStyles, xlInnerTitleStyles, xlSubContainerStyles, xlSubInnerTitleStyles, xlSubTitleStyles, xlTitleContainerStyles, xlTitleStyles, xxlContainerStyles, xxlInnerTitleStyles, xxlSubContainerStyles, xxlSubInnerTitleStyles, xxlSubTitleStyles, xxlTitleContainerStyles, xxlTitleStyles } from "../Common/Styles/CommonStyles";
import { useBreakpoint } from "../../../Container/ContainerStyles";
import { BreakpointType } from "../../../Container/ContainerFluid";
import { innerRowTitleStyles, lgInnerRowTitleStyles, listContainerStyles, mdInnerRowTitleStyles, smInnerRowTitleStyles, xlInnerRowTitleStyles, xxlInnerRowTitleStyles } from "./Styles/RegisterTrialEvaluationStyles";
import { IRegisterContext, useRegisterContext } from "../../RegisterContainer";
import { useCallback, useEffect, useState } from "react";
import { Lead, LeadTrialExperience } from "../../../../../Model/PartnerModels";
import { RegisterMessageBar } from "../Common/RegisterErrorBar";
import { RegisterService } from "../../Service/RegisterService";
import { RegisterEvaluationRow } from "./Components/RegisterEvaluationRow";

export const RegisterTrialEvaluation: React.FC = () => {
    const registerContext: IRegisterContext = useRegisterContext();
    const [lead, setLead] = useState<Lead>(registerContext.leadToLive.lead);
    
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);

    const saveLeadFields = useCallback((leadTrialExperience: LeadTrialExperience, leadEvaluationMode: number) => {
        setLead({
            ...lead,
            trialExperience: leadTrialExperience,
            evaluationMode: leadEvaluationMode === 2 ? 2 : 1,            
            setupCompanyCompleted: true
        });
    }, []);

    useEffect(() => {
        registerContext.setLeadToLive({
            ...registerContext.leadToLive,
            lead: lead,
        });
    }, [lead]);
    
    return (
        <>
            <Stack
                className={
                    isSM ? 
                        smContainerStyles : 
                    isMD ? 
                        mdContainerStyles :
                    isLG ?
                        lgContainerStyles :
                    isXL ?
                        xlContainerStyles :
                    isXXL ?
                        xxlContainerStyles
                    :
                        containerStyles
                }
            >
                <Stack
                    className={
                        isSM ? 
                            smTitleContainerStyles : 
                        isMD ? 
                            mdTitleContainerStyles :
                        isLG ?
                            lgTitleContainerStyles :
                        isXL ?
                            xlTitleContainerStyles :
                        isXXL ?
                            xxlTitleContainerStyles
                        :
                            titleContainerStyles
                    }
                >
                    <Text 
                        className={
                            isSM ? 
                                smTitleStyles : 
                            isMD ? 
                                mdTitleStyles : 
                            isLG ?
                                lgTitleStyles :
                            isXL ?
                                xlTitleStyles :
                            isXXL ?
                                xxlTitleStyles
                            :
                                titleStyles
                        }
                    >
                        {RegisterService.translate("trialEvaluation:title")}
                    </Text>
                    <Text 
                        className={
                            isSM ? 
                                smSubTitleStyles : 
                            isMD ? 
                                mdSubTitleStyles :
                            isLG ?
                                lgSubTitleStyles :
                            isXL ?
                                xlSubTitleStyles :
                            isXXL ?
                                xxlSubTitleStyles
                            :
                                subTitleStyles
                        }
                    >
                        {RegisterService.translate("trialEvaluation:description")}
                    </Text>
                </Stack>
                <Stack
                    className={formContainerStyles}
                >
                    <Stack>
                        <RegisterMessageBar 
                            type={MessageBarType.error}
                            visible={registerContext.registerError.hasError}
                            message={RegisterService.getErrorMessage(registerContext.registerError)}
                        />
                    </Stack>
                    <Stack
                        className={listContainerStyles}
                    >
                        <RegisterEvaluationRow 
                            title={RegisterService.translate("trialEvaluation:expressRowTitle")}
                            description={RegisterService.translate("trialEvaluation:expressRowDescription")}
                            onChange={() => saveLeadFields(LeadTrialExperience.Express, lead.evaluationMode)}
                            selected={lead.trialExperience === LeadTrialExperience.Express}
                        />
                        <RegisterEvaluationRow 
                            title={RegisterService.translate("trialEvaluation:intermidiateRowTitle")}
                            description={RegisterService.translate("trialEvaluation:intermidiateRowDescription")}
                            onChange={() => saveLeadFields(LeadTrialExperience.Intermediate, lead.evaluationMode)}
                            selected={lead.trialExperience === LeadTrialExperience.Intermediate}
                        />
                        <RegisterEvaluationRow 
                            title={RegisterService.translate("trialEvaluation:completeRowTitle")}
                            description={RegisterService.translate("trialEvaluation:completeRowDescription")}
                            onChange={() => saveLeadFields(LeadTrialExperience.Complete, lead.evaluationMode)}
                            selected={lead.trialExperience === LeadTrialExperience.Complete}
                        />
                    </Stack>
                </Stack>
                <Stack
                    className={
                        isSM ? 
                            smSubContainerStyles : 
                        isMD ? 
                            mdSubContainerStyles :
                        isLG ?
                            lgSubContainerStyles :
                        isXL ?
                            xlSubContainerStyles :
                        isXXL ?
                            xxlSubContainerStyles
                        :
                            subContainerStyles
                    }
                >
                    <Stack
                        className={
                            isSM ? 
                                smTitleContainerStyles : 
                            isMD ? 
                                mdTitleContainerStyles :
                            isLG ?
                                lgTitleContainerStyles :
                            isXL ?
                                xlTitleContainerStyles :
                            isXXL ?
                                xxlTitleContainerStyles
                            :
                                titleContainerStyles
                        }
                    >
                        <Stack
                            className={
                                isSM ? 
                                    smTitleContainerStyles : 
                                isMD ? 
                                    mdTitleContainerStyles :
                                isLG ?
                                    lgTitleContainerStyles :
                                isXL ?
                                    xlTitleContainerStyles :
                                isXXL ?
                                    xxlTitleContainerStyles
                                :
                                    titleContainerStyles
                            }
                        >
                            <Text 
                                className={
                                    isSM ? 
                                        smInnerTitleStyles : 
                                    isMD ? 
                                        mdInnerTitleStyles : 
                                    isLG ?
                                        lgInnerTitleStyles :
                                    isXL ?
                                        xlInnerTitleStyles :
                                    isXXL ?
                                        xxlInnerTitleStyles
                                    :
                                        innerTitleStyles
                                }
                            >
                                {RegisterService.translate("trialEvaluation:innerTitle")}
                            </Text>
                            <Text 
                                className={
                                    isSM ? 
                                        smSubInnerTitleStyles : 
                                    isMD ? 
                                        mdSubInnerTitleStyles :
                                    isLG ?
                                        lgSubInnerTitleStyles :
                                    isXL ?
                                        xlSubInnerTitleStyles :
                                    isXXL ?
                                        xxlSubInnerTitleStyles
                                    :
                                        subInnerTitleStyles
                                }
                            >
                                {RegisterService.translate("trialEvaluation:innerDescription")}
                            </Text>
                        </Stack>
                        <Stack
                            className={formContainerStyles}
                        >
                            <RegisterEvaluationRow 
                                title={RegisterService.translate("trialEvaluation:innerCheckbox")}
                                description=""
                                asCheckbox
                                // onChange={(selected) =>{setEvaluationMode(selected ? 2 : 1)}}
                                onChange={(selected) => saveLeadFields(lead.trialExperience, selected ? 2 : 1)}
                                selected={lead.evaluationMode === 2}
                                customTitleClassName={
                                    isSM ? 
                                        smInnerRowTitleStyles : 
                                    isMD ? 
                                        mdInnerRowTitleStyles :
                                    isLG ?
                                        lgInnerRowTitleStyles :
                                    isXL ?
                                        xlInnerRowTitleStyles :
                                    isXXL ?
                                        xxlInnerRowTitleStyles
                                    :
                                        innerRowTitleStyles
                                }
                            />
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </>
    );
}